import React from 'react';
import { useViewport } from '@xyflow/react';
import { CollaboratorInfo } from '@/lib/workflows/useYjsAwareness';

interface Props {
  collaborators: CollaboratorInfo[];
}

export default function CollaboratorCursors({ collaborators }: Props) {
  const { x, y, zoom } = useViewport();

  return (
    <div className='pointer-events-none absolute inset-0 z-50'>
      {collaborators
        .filter((c) => c.cursor)
        .map((c) => {
          const sx = (c.cursor!.x ?? 0) * zoom + x;
          const sy = (c.cursor!.y ?? 0) * zoom + y;
          const color = c.color || '#3b82f6';
          const showClick = !!c.click && Date.now() - (c.click!.at || 0) < 400;
          const clickOpacity = c.click
            ? Math.max(0, 1 - (Date.now() - c.click.at) / 400)
            : 0;

          return (
            <div
              key={c.clientId}
              style={{
                transform: `translate(${sx}px, ${sy}px)`,
              }}
              className='absolute'
            >
              <div className='flex items-center gap-1'>
                {/* Cursor arrow using provided SVG path */}
                <svg
                  width={20}
                  height={20}
                  viewBox='0 0 24 24'
                  style={{
                    filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.3))',
                  }}
                >
                  <path
                    d='M20.5056 10.7754C21.1225 10.5355 21.431 10.4155 21.5176 10.2459C21.5926 10.099 21.5903 9.92446 21.5115 9.77954C21.4205 9.61226 21.109 9.50044 20.486 9.2768L4.59629 3.5728C4.0866 3.38983 3.83175 3.29835 3.66514 3.35605C3.52029 3.40621 3.40645 3.52004 3.35629 3.6649C3.29859 3.8315 3.39008 4.08635 3.57304 4.59605L9.277 20.4858C9.50064 21.1088 9.61246 21.4203 9.77973 21.5113C9.92465 21.5901 10.0991 21.5924 10.2461 21.5174C10.4157 21.4308 10.5356 21.1223 10.7756 20.5054L13.3724 13.8278C13.4194 13.707 13.4429 13.6466 13.4792 13.5957C13.5114 13.5506 13.5508 13.5112 13.5959 13.479C13.6468 13.4427 13.7072 13.4192 13.828 13.3722L20.5056 10.7754Z'
                    fill='none'
                    stroke={color}
                    strokeWidth={2}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                {/* Label */}
                <div
                  className='px-2 py-0.5 rounded text-xs font-medium shadow-sm'
                  style={{ background: 'rgba(17,24,39,0.85)', color: 'white' }}
                >
                  {c.name || 'User'}
                </div>
              </div>
              {/* Click pulse */}
              {showClick && (
                <div
                  className='absolute -inset-3 rounded-full border-2'
                  style={{
                    borderColor: color,
                    opacity: clickOpacity,
                  }}
                />
              )}
            </div>
          );
        })}
    </div>
  );
}
